import { render, staticRenderFns } from "./360Babylon.vue?vue&type=template&id=8a8411b4&scoped=true&"
import script from "./360Babylon.vue?vue&type=script&lang=js&"
export * from "./360Babylon.vue?vue&type=script&lang=js&"
import style0 from "./360Babylon.vue?vue&type=style&index=0&id=8a8411b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a8411b4",
  null
  
)

export default component.exports